export const FETCH_UPDATE_DOCUMENTS_REQUEST = 'FETCH_UPDATE_DOCUMENTS_REQUEST'
export const FETCH_UPDATE_DOCUMENTS_SUCCESS = 'FETCH_UPDATE_DOCUMENTS_SUCCESS'
export const FETCH_UPDATE_DOCUMENTS_FALUIRE = 'FETCH_UPDATE_DOCUMENTS_FALUIRE'
